/**
 * LegalPage — shared chrome for Privacy, Terms and Support.
 * Matches the Landing dark theme so the pages don't feel like a
 * bolt-on afterthought (which is what App Reviewers actually check).
 */
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, updated, children, testId }) {
  return (
    <div className="min-h-screen bg-neutral-950 text-white antialiased" data-testid={testId || "legal-page"}>
      {/* --- Header --- */}
      <header className="sticky top-0 z-40 border-b border-white/5 bg-neutral-950/80 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/za-logo-icon.png" alt="ZA Player Pro" className="h-8 w-8 rounded-lg" />
            <span className="font-bold">ZA Player Pro</span>
          </Link>
          <Link to="/">
            <Button
              variant="outline"
              size="sm"
              className="border-white/10 bg-white/5 text-white hover:bg-white/10"
              data-testid="legal-back-button"
            >
              <ArrowLeft className="mr-2 h-4 w-4" /> Back to site
            </Button>
          </Link>
        </div>
      </header>

      {/* --- Content --- */}
      <main className="mx-auto max-w-3xl px-6 py-16">
        <div className="mb-2 text-xs font-semibold uppercase tracking-[0.25em] text-emerald-400">
          Legal
        </div>
        <h1 className="text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
          {title}
        </h1>
        {updated && (
          <p className="mt-3 text-sm text-neutral-400">
            Last updated <span className="text-neutral-200">{updated}</span>
          </p>
        )}

        <div
          className="prose prose-invert mt-10 max-w-none prose-headings:text-white prose-headings:font-semibold prose-h2:mt-10 prose-h2:text-2xl prose-h3:text-lg prose-p:text-neutral-300 prose-p:leading-relaxed prose-li:text-neutral-300 prose-a:text-emerald-400 prose-a:no-underline hover:prose-a:underline prose-strong:text-white prose-code:text-emerald-300"
        >
          {children}
        </div>
      </main>

      {/* --- Footer --- */}
      <footer className="border-t border-white/5 py-8 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} ZA Player Pro · Player-only application, no content included.
      </footer>
    </div>
  );
}
